import { render, staticRenderFns } from "./CustomFormGroup.vue?vue&type=template&id=2b76a9cc&scoped=true&lang=pug"
import script from "./CustomFormGroup.vue?vue&type=script&lang=js"
export * from "./CustomFormGroup.vue?vue&type=script&lang=js"
import style0 from "./CustomFormGroup.vue?vue&type=style&index=0&id=2b76a9cc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b76a9cc",
  null
  
)

export default component.exports